<template>
  <main-layout>
    <base-header>
      <template #icon> mdi-file</template>
      <template #name>Daily Sales Order </template>
      <template #breadcrumbs>
        <v-breadcrumbs :items="breadcrumbs" class="pa-0">
          <template #divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </template>
      <template #button>
      </template>
    </base-header>
    <v-row dense class="mx-1">
      <v-responsive width="100%" v-if="$vuetify.breakpoint.xsOnly" />
      <daily-sales-order-list />
    </v-row>
  </main-layout>
</template>

<script>
import { mapGetters } from "vuex";
import MainLayout from "@/layouts/MainLayout.vue";
import BaseHeader from "@/components/base/BaseHeader.vue";
import DailySalesOrderList from "./List.vue";
export default {
  name: "SalesOrderIndex",

  created() {
    this.breadcrumbs = [
      { text: "Transaction", disabled: false, to: "/dashboard" },
      { text: "Daily Sales Order", disabled: true },
      { text: "List", disabled: true },
    ];
  },

  computed: {
    ...mapGetters("auth", {
      CAN: "Can",
    }),
  },

  components: {
    MainLayout,
    BaseHeader,
    "daily-sales-order-list": DailySalesOrderList,
  },
};
</script>
<style scoped>
::v-deep .v-data-table-header {
  background-color: #ebebeb59;
}

::v-deep th {
  color: #000 !important;
}
</style>